import { render, staticRenderFns } from "./ClientProjectsEditDetailsStep5.vue?vue&type=template&id=afb619ee&scoped=true&"
import script from "./ClientProjectsEditDetailsStep5.vue?vue&type=script&lang=js&"
export * from "./ClientProjectsEditDetailsStep5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb619ee",
  null
  
)

export default component.exports